export default "__VITE_ASSET__Dv3foZ0n__"